import { useEffect, useRef, useState } from 'react';

/** Başa dön düğmesinin görünme eşiği (px): ilk ekranda gereksiz durmasın. */
const SCROLL_THRESHOLD = 480;

/**
 * Kaydırma durumu: `showTop` (eşik aşıldı mı) ve `progress` (0..1). Ölçüm kare başına bir kez (rAF): kaydırma olayı
 * çok sık gelir, state yalnız animasyon karesinde güncellenir. SSR'da `showTop` false, `progress` 0 başlar.
 * Başa dön halkası (`FloatingActions`) ve iletişim çubuğunun başa dön parçası (`ContactDock`) paylaşır.
 */
export function useScrollProgress() {
  const [showTop, setShowTop] = useState(false);
  const [progress, setProgress] = useState(0);
  const frame = useRef<number | null>(null);

  useEffect(() => {
    const measure = () => {
      frame.current = null;
      const y = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setShowTop(y > SCROLL_THRESHOLD);
      setProgress(max > 0 ? Math.min(1, Math.max(0, y / max)) : 0);
    };
    const onScroll = () => {
      if (frame.current === null) frame.current = window.requestAnimationFrame(measure);
    };
    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      if (frame.current !== null) window.cancelAnimationFrame(frame.current);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return { showTop, progress };
}
